import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import { GetFinanceReportsRequest } from 'app/models/partner/get-finance-reports-request';
import { GetFinanceReportsResponse } from 'app/models/partner/get-finance-reports-response';
import { GetFinanceSettlementReportsRequest } from 'app/models/partner/get-finance-settlement-reports-request';
import { GetFinanceSettlementReportsResponse } from 'app/models/partner/get-finance-settlement-reports-response';

@Injectable()
export class PartnerFinanceService {
  constructor(private apiHttp: ApiHttp) {}

  public getFinanceReports(
    data: GetFinanceReportsRequest,
    messageService: MessageService
  ): Promise<GetFinanceReportsResponse> {
    return this.apiHttp.post(
      'api/AdminPartnerFinance/GetFinanceReports',
      data,
      messageService
    );
  }

  public getFinanceSettlementReports(
    data: GetFinanceSettlementReportsRequest,
    messageService: MessageService
  ): Promise<GetFinanceSettlementReportsResponse> {
    return this.apiHttp.post(
      'api/AdminPartnerFinance/GetFinanceSettlementReports',
      data,
      messageService
    );
  }

  public exportFinanceReports(
    data: GetFinanceReportsRequest,
    messageService: MessageService
  ): Promise<any> {
    return this.apiHttp.postDownloadFile(
      'api/AdminPartnerFinance/ExportFinanceReports',
      data,
      messageService
    );
  }

  public exportFinanceSettlementReports(
    data: GetFinanceSettlementReportsRequest,
    messageService: MessageService
  ): Promise<any> {
    return this.apiHttp.postDownloadFile(
      'api/AdminPartnerFinance/ExportFinanceSettlementReports',
      data,
      messageService
    );
  }
}
